import { useMutation } from "@tanstack/react-query";
import { profile } from "@shared/api/services";

export const useAddCard = () => {
	return useMutation({
		mutationFn: () => profile.addCard(),
	});
};
